import withLayout from 'apps/web-client/src/hoc/with-layout';
import React from 'react';

import EditGroupController from './edit-group.controller';

const EditGroupScreen: React.FC = () => {
  return <EditGroupController />;
};
export default withLayout(EditGroupScreen);
